import { KubesoloHostResult, KubesoloStepState } from '@api/types.gen';

import { StepIcon } from './StepIcon';
import { formatDuration, stepDurationMs } from './durations';
import { stepLabels } from './steps';

/** A failed step is explained in the machine's details, and steps that never ran have nothing to say. */
const listedStates: Array<KubesoloStepState> = ['passed', 'running'];

export function hasListedSteps(host: KubesoloHostResult) {
  return host.steps.some((step) => listedStates.includes(step.state));
}

/** The steps that passed or are running, with how long each took and what it found. */
export function StepList({
  host,
  now,
}: {
  host: KubesoloHostResult;
  now: number;
}) {
  const steps = host.steps.filter((step) => listedStates.includes(step.state));

  return (
    <table className="w-auto" aria-label={`Steps of ${host.host}`}>
      <tbody>
        {steps.map((step) => (
          <tr key={step.name}>
            <td className="pr-3 align-top">
              <StepIcon step={step} />
            </td>
            <td className="pr-3 align-top !whitespace-nowrap">
              {stepLabels[step.name]}
            </td>
            <td className="pr-3 text-right align-top !whitespace-nowrap">
              {formatDuration(stepDurationMs(step, now))}
            </td>
            <td className="break-words">{step.detail}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
